function Page({ className, children }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className='app mx-auto'>{children}</div>;
}

export { Page };
